import { applyMiddleware, createStore } from "redux";
import { Middlewares } from "../middlewares";
import appReducer from "../reducers/index.reducer";

export default (initialState = {}) => {
  return applyMiddleware(...Middlewares)(createStore)(appReducer, initialState);
};
